<button class="login-button" (click)="login()">{{ text }}</button>
